
import { defineComponent } from 'vue';
import type { PropType } from 'vue';
import type { types } from '../../api_types';
import T from '../../lang';
import Notification from './Notification.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
library.add(faBell);

export default defineComponent({
  name: 'NotificationList',
  components: {
    FontAwesomeIcon,
    'omegaup-notification': Notification,
  },
  props: {
    notifications: {
      type: Array as PropType<types.Notification[]>,
      default: () => [],
    },
  },
  data() {
    return {
      T,
    };
  },
  methods: {
    readSingleNotification(
      notification: types.Notification,
      url?: string,
    ): void {
      this.$emit('read', [notification], url);
    },
  },
});
